import React, { useState, useEffect } from "react";
import AuthPage from "./components/AuthPage";
import NotesPage from "./components/NotesPage";
import { refreshTokenFunc } from "./api/auth";
import HamburgerMenu from "./components/HamburgerMenu";
import SharedNotesPage from "./components/SharedNotesPage";

function App() {
  const useAuth = process.env.REACT_APP_USE_AUTH === "true"; // Check if auth is enabled
  const [authToken, setAuthToken] = useState(localStorage.getItem("authToken"));
  const [refreshTokenValue, setRefreshTokenValue] = useState(localStorage.getItem("refreshToken"));
  const [tokenExpiry, setTokenExpiry] = useState(localStorage.getItem("tokenExpiry"));
  const [userEmail, setUserEmail] = useState(localStorage.getItem("userEmail"));
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState("");
  const [view, setView] = useState("notes"); // State to track the current view

  // Automatically refresh the token if it's about to expire
  useEffect(() => {
    if (useAuth && (!authToken || !refreshTokenValue || !tokenExpiry)) return;

    const interval = setInterval(async () => {
      if (Date.now() > tokenExpiry - 60000) { // Refresh 1 minute before expiry
        setLoading(true);
        setError("");
        try {
          const { accessToken, refreshToken, expiresIn, email } = await refreshTokenFunc(refreshTokenValue); // Get new tokens
          setAuthToken(accessToken);
          setTokenExpiry(Date.now() + expiresIn * 1000);
          setRefreshTokenValue(refreshToken);
          setUserEmail(email);

          // Store tokens in localStorage
          localStorage.setItem("authToken", accessToken);
          localStorage.setItem("refreshToken", refreshToken);
          localStorage.setItem("tokenExpiry", Date.now() + expiresIn * 1000);
          localStorage.setItem("userEmail", email);
        } catch (error) {
          console.error("Failed to refresh token:", error);
          setAuthToken(null);
          setRefreshTokenValue(null);
          setTokenExpiry(null);
          setUserEmail(null);
          setError("Failed to refresh token. Please sign in again.");
          localStorage.clear();
        } finally {
          setLoading(false);
        }
      }
    }, 30000); // Check every 30 seconds

    return () => clearInterval(interval);
  }, [useAuth, authToken, refreshTokenValue, tokenExpiry]);


  const handleLogout = () => {
    setAuthToken(null);
    setRefreshTokenValue(null);
    setTokenExpiry(null);
    setUserEmail(null);
    localStorage.clear();
  };

  if (useAuth && !authToken) {
    return <AuthPage setAuthToken={setAuthToken} />;
  }


  return (
    <div>
      <HamburgerMenu setView={setView} handleLogout={handleLogout} />
      <div>
        {loading && <div>Loading...</div>}
        {error && <div className="error-message">{error}</div>}
        {view === "notes" && <NotesPage token={authToken} setAuthToken={setAuthToken} />}
        {view === "shared-notes" && <SharedNotesPage token={authToken} />}
      </div>
    </div>
  );
}

export default App;